import clsx from "clsx"
import { FC } from "react"
import { getEncumbranceFill, getEncumbranceStyle } from "@/helpers/encumbrance"
import styles from "./NavButton.module.scss"
import { INavButtonProps } from "./types"

export const NavButton: FC<INavButtonProps> = ({
  icon,
  label,
  active,
  onClick,
  encumbrance
}) => (
  <button
    type="button"
    className={clsx(styles.NavButton, { [styles.active]: active })}
    onClick={onClick}
  >
    <img className={styles.NavButton_icon} src={icon} alt="" />
    {encumbrance !== undefined && (
      <span
        className={styles.NavButton_gauge}
        style={getEncumbranceStyle(encumbrance)}
      >
        <span
          className={styles.NavButton_gaugeFill}
          style={{ width: `${getEncumbranceFill(encumbrance) * 100}%` }}
        />
      </span>
    )}
    <span className={styles.NavButton_label}>{label}</span>
  </button>
)
